__turbopack_context__.v({
  "store-tile": "_5-e2rq_store-tile",
  "store-tile__store-details": "_5-e2rq_store-tile__store-details",
  "store-tile__store-info": "_5-e2rq_store-tile__store-info",
});
